package com.vizio.redwolf.auth.api

import com.vizio.redwolf.auth.client.AccountHttpClient
import com.vizio.redwolf.auth.model.AccountAbuseFormInfo
import com.vizio.redwolf.auth.model.AccountAuthCodeRequestInfo
import com.vizio.redwolf.auth.model.AccountAuthCodeResponse
import com.vizio.redwolf.auth.model.AccountEmailExistsRequestBody
import com.vizio.redwolf.auth.model.AccountEmailExistsResponse
import com.vizio.redwolf.auth.model.AccountEmailExistsSDKRequestBody
import com.vizio.redwolf.auth.model.AccountForgotPasswordInfo
import com.vizio.redwolf.auth.model.AccountForgotPasswordSDKInfo
import com.vizio.redwolf.auth.model.AccountProducts
import com.vizio.redwolf.auth.model.AccountRefreshTokenInfo
import com.vizio.redwolf.auth.model.AccountRegisterProductInfo
import com.vizio.redwolf.auth.model.AccountRegisteredProductsResponse
import com.vizio.redwolf.auth.model.WalmartAccountRelinkResponse
import com.vizio.redwolf.auth.model.AccountRequestJwtResponse
import com.vizio.redwolf.auth.model.AccountResult
import com.vizio.redwolf.auth.model.AccountSerialNumberInfo
import com.vizio.redwolf.auth.model.AccountSerialNumberResponse
import com.vizio.redwolf.auth.model.AccountShippingAddress
import com.vizio.redwolf.auth.model.AccountUnsubscribeInfo
import com.vizio.redwolf.auth.model.AccountUnsubscribeSDKInfo
import com.vizio.redwolf.auth.model.AccountUser
import com.vizio.redwolf.auth.model.AccountUserEmailPreference
import com.vizio.redwolf.auth.model.SwapOneOrAllDevicesClientRequestInfo
import com.vizio.redwolf.auth.model.SwapOneOrAllDevicesRequestInfo
import com.vizio.redwolf.auth.model.ConvertToWalmartAccountWithSetupCodeRequestInfo
import com.vizio.redwolf.auth.model.CreateAccount2ClientRequestInfo
import com.vizio.redwolf.auth.model.CreateAccount2RequestInfo
import com.vizio.redwolf.auth.model.CreateAccountClientRequestInfo
import com.vizio.redwolf.auth.model.CreateAccountRequestInfo
import com.vizio.redwolf.auth.model.CreateAccountResponse
import com.vizio.redwolf.auth.model.EmailVerifiedRequestInfo
import com.vizio.redwolf.auth.model.EmailVerifiedResponse
import com.vizio.redwolf.auth.model.GenericAccountResponse
import com.vizio.redwolf.auth.model.LoginClientRequestInfo
import com.vizio.redwolf.auth.model.LoginRequestInfo
import com.vizio.redwolf.auth.model.LoginResponse
import com.vizio.redwolf.auth.model.MigrateGuestAccountResponse
import com.vizio.redwolf.auth.model.MigrateGuestClientRequestInfo
import com.vizio.redwolf.auth.model.MigrateGuestRequestInfo
import com.vizio.redwolf.auth.model.RefreshJwtRequestInfo
import com.vizio.redwolf.auth.model.RefreshTokenResponse
import com.vizio.redwolf.auth.model.RequiresVerificationRequestInfo
import com.vizio.redwolf.auth.model.RequiresVerificationResponse
import com.vizio.redwolf.auth.model.SendTermsEmailResponse
import com.vizio.redwolf.auth.model.SendTermsRequestInfo
import com.vizio.redwolf.auth.model.SendVerificationEmailRequestInfo
import com.vizio.redwolf.auth.model.SendVerificationEmailResponse
import com.vizio.redwolf.auth.model.SocialLoginClientRequestInfo
import com.vizio.redwolf.auth.model.SocialLoginRequestInfo
import com.vizio.redwolf.auth.model.UpdateEmailClientRequestInfo
import com.vizio.redwolf.auth.model.UpdateEmailRequestInfo
import com.vizio.redwolf.auth.model.UpdateEmailV2ClientRequestInfo
import com.vizio.redwolf.auth.model.UpdateEmailV2RequestInfo
import com.vizio.redwolf.auth.model.UpdatePasswordInfo
import com.vizio.redwolf.auth.model.UpdateUserDetailsClientRequestInfo
import com.vizio.redwolf.auth.model.UpdateUserDetailsRequestInfo
import com.vizio.redwolf.auth.model.UserDetailsRequestInfo
import com.vizio.redwolf.auth.model.ConvertWalmartAccountRequestInfo
import com.vizio.redwolf.auth.model.ConvertWalmartAccountWithTokenClientRequestInfo
import com.vizio.redwolf.auth.model.ConvertWalmartAccountWithTokenRequestInfo
import com.vizio.redwolf.auth.model.CreateWalmartAccountRequestInfo
import com.vizio.redwolf.auth.model.DeleteVizioAccountRequestInfo
import com.vizio.redwolf.auth.model.DeleteVizioAccountResponse
import com.vizio.redwolf.auth.model.WalmartLoginClientRequestInfo
import com.vizio.redwolf.auth.model.WalmartLoginRequestInfo
import com.vizio.redwolf.auth.model.EmailOTPRequestInfo
import com.vizio.redwolf.auth.model.EmailOTPResponse
import com.vizio.redwolf.auth.model.VerifyEmailOTPRequestInfo
import com.vizio.redwolf.auth.model.WalmartAccountDeviceRelinkClientRequestInfo
import com.vizio.redwolf.auth.model.WalmartAccountDeviceRelinkRequestInfo
import com.vizio.redwolf.auth.model.VerifyEmailOTPWithSetupCodeRequestInfo
import com.vizio.redwolf.auth.model.EmailOTPWithSetupCodeRequestInfo
import com.vizio.redwolf.auth.model.SwapOneOrAllDevicesResponse
import com.vizio.redwolf.auth.model.VerifyEmailOTPResponse
import com.vizio.redwolf.auth.model.WalmartLoginViaSetupCodeClientRequestInfo
import com.vizio.redwolf.auth.model.WalmartLoginViaSetupCodeRequestInfo
import com.vizio.redwolf.auth.model.WalmartRequestOTPWithSetupCodeResponse
import com.vizio.redwolf.auth.model.WalmartVerifyOTPWithSetupCodeResponse
import com.vizio.redwolf.auth.model.WebEmailVerificationClientRequestInfo
import com.vizio.redwolf.auth.model.WebEmailVerificationRequestInfo
import com.vizio.redwolf.auth.model.WebVerifyTokenResponse
import com.vizio.redwolf.auth.utils.JwtTokenRefreshManager
import com.vizio.redwolf.auth.utils.JwtValidationResult
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.ECommerceEnvironmentConfig
import com.vizio.redwolf.utils.HttpResult
import com.vizio.redwolf.utils.MessageTokenUtil
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.Platform
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.TimeoutException
import com.vizio.redwolf.utils.choosePayEnvironment
import com.vizio.redwolf.utils.clientprovider.ClientConfigFactory
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import com.vizio.redwolf.utils.model.PayFailureResponse
import com.vizio.redwolf.utils.platform
import com.vizio.redwolf.utils.retryRequest
import io.ktor.client.call.NoTransformationFoundException
import io.ktor.client.call.body
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.request
import io.ktor.http.isSuccess
import io.ktor.util.decodeBase64String

class AccountApi(
    private val environment: PayEnvironment,
    private val appConfig: AppConfig,
    private val clientConfig: ClientConfig = ClientConfigFactory.getClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
) : AccountApiInterface {

    private val httpClient = AccountHttpClient(payEnv = environment, appConfig = appConfig, clientConfig = clientConfig)

    //TODO: Some clean up to be done
    private val messageTokenDecrypted = environment.messageTokenAESKeyMasked?.decodeBase64String()?.let { it.substring(0, it.length - 5).reversed() }

    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig) : this(choosePayEnvironment(envConfig), appConfig)
    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig, clientConfig: ClientConfig) : this(choosePayEnvironment(envConfig), appConfig, clientConfig)
    constructor(envConfig: ECommerceEnvironmentConfig, appConfig: AppConfig, timeout: Long) : this(choosePayEnvironment(envConfig), appConfig, ClientConfigFactory.getClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS, timeout))

    companion object {
        const val ERROR_CONTENT_TYPE_NOT_SUPPORTED = "NoTransformationFoundException: Response ContentType is not supported"
    }

    internal fun getMessageToken(email: String): String? {
        val messageToken = when (platform) {
            Platform.Android, Platform.iOS -> {
                messageTokenDecrypted?.let { aesKey ->
                    MessageTokenUtil().generateMessageToken(email, aesKey)
                }
            }

            Platform.JS -> {
                null
            }
        }
        return messageToken
    }

    override suspend fun createAccount(requestInfo: CreateAccountRequestInfo, traceId: String?): AccountResult<CreateAccountResponse> {
        val messageToken = getMessageToken(requestInfo.email)
        val clientRequestInfo = CreateAccountClientRequestInfo(
            email = requestInfo.email,
            password = requestInfo.password,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken,
            birthDate = requestInfo.birthDate,
            gender = requestInfo.gender
        )
        return retryAccountRequest {
            val httpResult = httpClient.createAccount(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun createAccount2(requestInfo: CreateAccount2RequestInfo, traceId: String?): AccountResult<CreateAccountResponse> {
        val messageToken = getMessageToken(requestInfo.email)
        val clientRequestInfo = CreateAccount2ClientRequestInfo(
            email = requestInfo.email,
            password = requestInfo.password,
            firstName = requestInfo.firstName,
            lastName = requestInfo.lastName,
            postalCode = requestInfo.postalCode,
            phoneNumber = requestInfo.phoneNumber,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken,
            birthDate = requestInfo.birthDate,
            gender = requestInfo.gender
        )
        return retryAccountRequest {
            val httpResult = httpClient.createAccount(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun login(requestInfo: LoginRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        val messageToken = getMessageToken(requestInfo.email)
        val clientRequestInfo = LoginClientRequestInfo(
            email = requestInfo.email,
            password = requestInfo.password,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.login(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun socialLogin(requestInfo: SocialLoginRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        val messageToken = requestInfo.email?.let { getMessageToken(it) }
        val clientRequestInfo = SocialLoginClientRequestInfo(
            email = requestInfo.email,
            facebookToken = requestInfo.facebookToken,
            googleToken = requestInfo.googleToken,
            appleToken = requestInfo.appleToken,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.login(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun requestUserDetails(requestInfo: UserDetailsRequestInfo, traceId: String?): AccountResult<AccountUser> {
        return retryAccountRequest {
            val httpResult = httpClient.requestUserDetails(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun updateUserDetails(requestInfo: UpdateUserDetailsRequestInfo, traceId: String?): AccountResult<AccountUser> {
        val clientRequestInfo = UpdateUserDetailsClientRequestInfo(
            firstName = requestInfo.firstName,
            lastName = requestInfo.lastName,
            phoneNumber = requestInfo.phoneNumber,
            postalCode = requestInfo.postalCode,
            birthDate = requestInfo.birthDate,
            gender = requestInfo.gender
        )
        return retryAccountRequest {
            val httpResult = httpClient.updateUserDetails(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun checkIfEmailVerified(requestInfo: EmailVerifiedRequestInfo, traceId: String?): AccountResult<EmailVerifiedResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.checkIfEmailVerified(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated and may be removed in future versions. Use alternative methods to check email verification status if available.")
    override suspend fun checkIfRequiresEmailVerification(requestInfo: RequiresVerificationRequestInfo, traceId: String?): AccountResult<RequiresVerificationResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.checkIfRequiresEmailVerification(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    //TODO: Handle status code here
    override suspend fun sendVerificationEmail(requestInfo: SendVerificationEmailRequestInfo, traceId: String?): AccountResult<SendVerificationEmailResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.sendVerificationEmail(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    //TODO: Handle status code here
    override suspend fun sendTermsEmail(requestInfo: SendTermsRequestInfo, traceId: String?): AccountResult<SendTermsEmailResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.sendTermsEmail(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("Use AccountApi migrateGuestAccountV2", replaceWith = ReplaceWith("migrateGuestAccountV2()"))
    override suspend fun migrateGuestAccount(requestInfo: MigrateGuestRequestInfo, traceId: String?): AccountResult<MigrateGuestAccountResponse> {
        val clientRequestInfo = MigrateGuestClientRequestInfo(
            email = requestInfo.email,
            password = requestInfo.password
        )
        return retryAccountRequest {
            val httpResult = httpClient.migrateGuestAccount(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use migrateGuestAccountV2 as the preferred way to migrate guest accounts.")
    override suspend fun migrateGuestAccountV2(requestInfo: MigrateGuestRequestInfo, traceId: String?): AccountResult<AccountUser> {
        val clientRequestInfo = MigrateGuestClientRequestInfo(
            email = requestInfo.email,
            password = requestInfo.password,
            birthDate = requestInfo.birthDate,
            gender = requestInfo.gender
        )
        return retryAccountRequest {
            val httpResult = httpClient.migrateGuestAccountV2(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("Use AccountApi updateEmailV2", replaceWith = ReplaceWith("updateEmailV2()"))
    override suspend fun updateEmail(requestInfo: UpdateEmailRequestInfo, traceId: String?): AccountResult<AccountUser> {
        val clientRequestInfo = UpdateEmailClientRequestInfo(
            email = requestInfo.email
        )
        return retryAccountRequest {
            val httpResult = httpClient.updateEmail(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun updateEmailV2(requestInfo: UpdateEmailV2RequestInfo, traceId: String?): AccountResult<AccountUser> {
        val messageToken = getMessageToken(requestInfo.email)
        val clientRequestInfo = UpdateEmailV2ClientRequestInfo(
            email = requestInfo.email,
            messageToken = messageToken,
            reCaptchaToken = requestInfo.reCaptchaToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.updateEmailV2(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }


    override suspend fun logout(authToken: String, traceId: String?): AccountResult<Unit> {
        return retryAccountRequest {
            val httpResult = httpClient.logout(authToken, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun resetPasswordRequest(forgotPasswordInfo: AccountForgotPasswordInfo, traceId: String?): AccountResult<GenericAccountResponse> {
        val messageToken = forgotPasswordInfo.email?.let { getMessageToken(it) }

        val forgotPasswordSDKInfo = AccountForgotPasswordSDKInfo(
            email = forgotPasswordInfo.email,
            reCaptchaToken = forgotPasswordInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.resetPasswordRequest(forgotPasswordSDKInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun updatePassword(authToken: String, pwInfo: UpdatePasswordInfo, traceId: String?): AccountResult<GenericAccountResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.updatePassword(authToken, pwInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun emailExists(emailExistsRequestBody: AccountEmailExistsRequestBody, traceId: String?): AccountResult<AccountEmailExistsResponse> {
        val messageToken = emailExistsRequestBody.email?.let { getMessageToken(it) }

        val emailExistsSDKRequestBody = AccountEmailExistsSDKRequestBody(
            email = emailExistsRequestBody.email,
            reCaptchaToken = emailExistsRequestBody.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.emailExists(emailExistsSDKRequestBody, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun refreshToken(lastRefreshToken: String, traceId: String?): AccountResult<RefreshTokenResponse> {
        return retryAccountRequest {
            val payRefreshTokenInfo = AccountRefreshTokenInfo(lastRefreshToken)
            val httpResult = httpClient.refreshToken(payRefreshTokenInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun requestJwt(authToken: String, traceId: String?): AccountResult<AccountRequestJwtResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.requestJwt(authToken, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    // Refresh Jwt with local expiry validation
    override suspend fun refreshJWTIfRequired(requestInfo: RefreshJwtRequestInfo, traceId: String?): JwtValidationResult {
        val jwtTokenRefreshManager = JwtTokenRefreshManager(environment, appConfig)
        return jwtTokenRefreshManager.validateJwt(requestInfo)
    }

    @Deprecated("This method is for web usage only and is deprecated for mobile app integration.")
    override suspend fun webVerifyToken(requestInfo: WebEmailVerificationRequestInfo, traceId: String?): AccountResult<WebVerifyTokenResponse> {
        val clientRequestInfo = WebEmailVerificationClientRequestInfo(
            emailVerificationToken = requestInfo.emailVerificationToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.webVerifyToken(requestInfo.accessToken, clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use alternative address management services if available.")
    override suspend fun getShippingAddress(authToken: String, sentryHeader: String?, traceId: String?): AccountResult<AccountShippingAddress> {
        return retryAccountRequest {
            val httpResult = httpClient.getShippingAddress(authToken, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use alternative address management services if available.")
    override suspend fun updateShippingAddress(authToken: String, newAddress: AccountShippingAddress, sentryHeader: String?, traceId: String?): AccountResult<AccountShippingAddress> {
        return retryAccountRequest {
            val httpResult = httpClient.updateShippingAddress(authToken, newAddress, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use newer product registration APIs if available.")
    override suspend fun getRegisteredProducts(authToken: String, sentryHeader: String?, traceId: String?): AccountResult<AccountRegisteredProductsResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.getRegisteredProducts(authToken, sentryHeader, traceId)
            when (val accountResult = handleAccountHttpResult<HttpResponse, List<AccountProducts>>(httpResult)) {
                is AccountResult.Success -> AccountResult.Success(accountResult.headers, AccountRegisteredProductsResponse(accountResult.data))
                is AccountResult.Failed -> accountResult
                is AccountResult.Error -> accountResult
                is AccountResult.Timeout -> accountResult
            }
        }
    }

    @Deprecated("This method is deprecated. Use newer product registration APIs if available.")
    override suspend fun updateRegisteredProducts(authToken: String, serialNumbers: List<String>, sentryHeader: String?, traceId: String?): AccountResult<AccountRegisteredProductsResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.updateRegisteredProducts(authToken, serialNumbers, sentryHeader, traceId)
            when (val accountResult = handleAccountHttpResult<HttpResponse, List<AccountProducts>>(httpResult)) {
                is AccountResult.Success -> AccountResult.Success(accountResult.headers, AccountRegisteredProductsResponse(accountResult.data))
                is AccountResult.Failed -> accountResult
                is AccountResult.Error -> accountResult
                is AccountResult.Timeout -> accountResult
            }
        }
    }

    @Deprecated("This method is deprecated. Use newer product registration APIs if available.")
    override suspend fun registerProduct(authToken: String, registerProductInfo: AccountRegisterProductInfo, sentryHeader: String?, traceId: String?): AccountResult<AccountRegisteredProductsResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.registerProduct(authToken, registerProductInfo, sentryHeader, traceId)
            when (val accountResult = handleAccountHttpResult<HttpResponse, List<AccountProducts>>(httpResult)) {
                is AccountResult.Success -> AccountResult.Success(accountResult.headers, AccountRegisteredProductsResponse(accountResult.data))
                is AccountResult.Failed -> accountResult
                is AccountResult.Error -> accountResult
                is AccountResult.Timeout -> accountResult
            }
        }
    }

    @Deprecated("This method is deprecated. Use newer product registration APIs if available.")
    override suspend fun unregisterProduct(authToken: String, serialNumber: String, sentryHeader: String?, traceId: String?): AccountResult<Unit> {
        return retryAccountRequest {
            val httpResult = httpClient.unregisterProduct(authToken, serialNumber, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use newer email preference management APIs if available.")
    override suspend fun getEmailPreference(authToken: String, sentryHeader: String?, traceId: String?): AccountResult<AccountUserEmailPreference> {
        return retryAccountRequest {
            val httpResult = httpClient.getEmailPreference(authToken, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use newer email preference management APIs if available.")
    override suspend fun updateEmailPreference(authToken: String, emailPreference: AccountUserEmailPreference, sentryHeader: String?, traceId: String?): AccountResult<AccountUserEmailPreference> {
        return retryAccountRequest {
            val httpResult = httpClient.updateEmailPreference(authToken, emailPreference, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use newer unsubscribe management APIs if available.")
    override suspend fun unsubscribe(unsubscribeInfo: AccountUnsubscribeInfo, sentryHeader: String?, traceId: String?): AccountResult<Unit> {
        val messageToken = unsubscribeInfo.email?.let { getMessageToken(it) }

        val unsubscribeSDKInfo = AccountUnsubscribeSDKInfo(
            email = unsubscribeInfo.email,
            reCaptchaToken = unsubscribeInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val response = httpClient.unsubscribe(unsubscribeSDKInfo, sentryHeader, traceId)
            handleAccountHttpResult(response)
        }
    }

    @Deprecated("This method is deprecated. Use newer abuse reporting APIs if available.")
    override suspend fun createAbuseReport(authToken: String, abuseFormInfo: AccountAbuseFormInfo, sentryHeader: String?, traceId: String?): AccountResult<Unit> {
        return retryAccountRequest {
            val abuseReportResponse = httpClient.createAbuseReport(authToken, abuseFormInfo, sentryHeader, traceId)
            handleAccountHttpResult(abuseReportResponse)
        }
    }

    @Deprecated("This method is deprecated. Use newer serial number validation APIs if available.")
    override suspend fun validateSerialNumber(authToken: String, serialNumber: AccountSerialNumberInfo, sentryHeader: String?, traceId: String?): AccountResult<AccountSerialNumberResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.validateSerialNumber(authToken, serialNumber, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    @Deprecated("This method is deprecated. Use newer authorization code request APIs if available.")
    override suspend fun requestAuthCode(accountAuthCodeRequestInfo: AccountAuthCodeRequestInfo, sentryHeader: String?, traceId: String?): AccountResult<AccountAuthCodeResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.requestAuthCode(accountAuthCodeRequestInfo, sentryHeader, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun walmartLogin(requestInfo: WalmartLoginRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        val messageToken = getMessageToken(requestInfo.authorizationCode)
        val clientRequestInfo = WalmartLoginClientRequestInfo(
            authorizationCode = requestInfo.authorizationCode,
            redirectUri = requestInfo.redirectUri,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.walmartLogin(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun walmartLoginWithSetupCode(requestInfo: WalmartLoginViaSetupCodeRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        val messageToken = getMessageToken(requestInfo.authorizationCode)
        val clientRequestInfo = WalmartLoginViaSetupCodeClientRequestInfo(
            authorizationCode = requestInfo.authorizationCode,
            redirectUri = requestInfo.redirectUri,
            setupCode = requestInfo.setupCode,
            reCaptchaToken = requestInfo.reCaptchaToken,
            messageToken = messageToken
        )
        return retryAccountRequest {
            val httpResult = httpClient.walmartLoginWithSetupCode(clientRequestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun createWalmartAccount(requestInfo: CreateWalmartAccountRequestInfo, traceId: String?): AccountResult<CreateAccountResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.createWalmartAccount(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun convertToWalmartAccount(requestInfo: ConvertWalmartAccountRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.convertToWalmartAccount(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun convertToWalmartAccountWithAccessToken(requestInfo: ConvertWalmartAccountWithTokenRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        val clientRequestInfo = ConvertWalmartAccountWithTokenClientRequestInfo(
            vzAuthCode = requestInfo.vzAuthCode,
        )
        return retryAccountRequest {
            val httpResult = httpClient.convertToWalmartAccountWithAccessToken(clientRequestInfo, requestInfo.accessToken, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun convertToWalmartAccountWithSetupCode(requestInfo: ConvertToWalmartAccountWithSetupCodeRequestInfo, traceId: String?): AccountResult<LoginResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.convertToWalmartAccountWithSetupCode(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun deleteVizioAccount(requestInfo: DeleteVizioAccountRequestInfo, traceId: String?): AccountResult<DeleteVizioAccountResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.deleteVizioAccount(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun requestEmailOTP(requestInfo: EmailOTPRequestInfo, traceId: String?): AccountResult<EmailOTPResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.requestEmailOTP(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun verifyEmailOTP(requestInfo: VerifyEmailOTPRequestInfo, traceId: String?): AccountResult<VerifyEmailOTPResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.verifyEmailOTP(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun requestEmailOTPWithSetupCode(requestInfo: EmailOTPWithSetupCodeRequestInfo, traceId: String?): AccountResult<WalmartRequestOTPWithSetupCodeResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.requestEmailOTPWithSetupCode(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun verifyEmailOTPWithSetupCode(requestInfo: VerifyEmailOTPWithSetupCodeRequestInfo, traceId: String?): AccountResult<WalmartVerifyOTPWithSetupCodeResponse> {
        return retryAccountRequest {
            val httpResult = httpClient.verifyEmailOTPWithSetupCode(requestInfo, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun walmartAccountDeviceRelink(requestInfo: WalmartAccountDeviceRelinkRequestInfo, traceId: String?): AccountResult<WalmartAccountRelinkResponse> {
        val clientRequestInfo = WalmartAccountDeviceRelinkClientRequestInfo(
            setupCode = requestInfo.setupCode
        )
        return retryAccountRequest {
            val httpResult = httpClient.walmartAccountDeviceRelink(clientRequestInfo, requestInfo.accessToken, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun swapOneOrAllDevices(requestInfo: SwapOneOrAllDevicesRequestInfo, traceId: String?): AccountResult<SwapOneOrAllDevicesResponse> {
        val clientRequestInfo = SwapOneOrAllDevicesClientRequestInfo(
            setupCode = requestInfo.setupCode,
            allDevices = requestInfo.allDevices,
        )
        return retryAccountRequest {
            val httpResult = httpClient.swapOneOrAllDevices(clientRequestInfo, requestInfo.accessToken, traceId)
            handleAccountHttpResult(httpResult)
        }
    }

    override suspend fun convertToWalmartAccountAndPerformRelink(requestInfo: ConvertToWalmartAccountWithSetupCodeRequestInfo, traceId: String?): AccountResult<WalmartAccountRelinkResponse> {
        when(val result = convertToWalmartAccountWithSetupCode(requestInfo, traceId)){
            is AccountResult.Success -> {
                val response = result.data
                val clientRequestInfo = WalmartAccountDeviceRelinkRequestInfo(
                    accessToken = response.token,
                    setupCode = requestInfo.setupCode
                )
                return walmartAccountDeviceRelink(clientRequestInfo, traceId)
            }
            is AccountResult.Failed -> {
                return AccountResult.Failed(result.headers, result.response)
            }
            is AccountResult.Error -> {
                return AccountResult.Error(result.headers, result.exception)
            }
            is AccountResult.Timeout -> {
                return AccountResult.Timeout(result.headers, result.exception)
            }
        }
    }

    private suspend inline fun <T : HttpResponse, reified R : Any> handleAccountHttpResult(httpResult: HttpResult<T>): AccountResult<R> {
        return when (httpResult) {
            is HttpResult.Success -> {
                val httpResponse: HttpResponse = httpResult.data
                val statusCode = httpResponse.status.value
                val requestUrl: String = httpResponse.request.url.toString()
                val headers = ResponseHeaders.Valid(statusCode)
                if (httpResponse.status.isSuccess()) {
                    try {
                        logToFile(httpResponse)
                        AccountResult.Success(headers, httpResponse.body())
                    } catch (ex: Exception) {
                        logToFile(httpResponse, throwable = ex)
                        ex.printStackTrace()
                        AccountResult.Error(headers, ex)
                    }
                } else {
                    try {
                        val failureMessage = httpResponse.body<PayFailureResponse>()
                        logToFile(httpResponse)
                        AccountResult.Failed(headers, response = failureMessage)
                    } catch (ex: NoTransformationFoundException) {
                        logToFile(httpResponse, throwable = ex)
                        ex.printStackTrace()
                        val exception = Exception("$ERROR_CONTENT_TYPE_NOT_SUPPORTED:$requestUrl")
                        AccountResult.Error(headers, exception)
                    } catch (ex: Exception) {
                        logToFile(httpResponse, throwable = ex)
                        ex.printStackTrace()
                        AccountResult.Error(headers, ex)
                    }
                }
            }

            is HttpResult.Error -> {
                val headers = ResponseHeaders.Invalid
                val exception = httpResult.exception
                logToFile(httpRequestInfo = httpResult.httpRequestInfo, throwable = exception)
                if (exception is TimeoutException) {
                    AccountResult.Timeout(headers, exception)
                } else {
                    AccountResult.Error(ResponseHeaders.Invalid, exception)
                }
            }
        }
    }

    private fun <T : Any> isAccountResultSuccess(result: T): Boolean {
        return result is AccountResult.Success<*>
    }

    private suspend inline fun <T : Any> retryAccountRequest(block: () -> T): T {
        return retryRequest(clientConfig, block, isSuccess = ::isAccountResultSuccess)
    }
}